/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxWeeks: NonNullable<unknown> }} Membership_Freeze_DescriptionInputs */

const fr_membership_freeze_description = /** @type {(inputs: Membership_Freeze_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Une pause par année de contrat (le droit revient à chaque reconduction), de 1 à ${i?.maxWeeks} semaines. Pendant la pause, vous ne pouvez pas réserver de cours ; votre prochain prélèvement et la fin de votre engagement sont décalés du même nombre de semaines.`)
};

/**

* @param {Membership_Freeze_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_description = /** @type {((inputs: Membership_Freeze_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_description(inputs)
});